import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './modules/core/error/error.component';
import { ActiveAgentsComponent } from './modules/core/main-widgets/active-agents/active-agents.component';
import { LoginComponent } from './modules/core/main-widgets/login/login.component';
import { LogoutComponent } from './modules/core/logout/logout.component';
const routes: Routes = [
  { path: '', component: LoginComponent },
   { path: 'home', component: ActiveAgentsComponent },
   { path: 'error', component: ErrorComponent},
   { path: 'logout', component: LogoutComponent},
   { path: 'home/**', pathMatch: 'full', component: ErrorComponent},
   { path: '**', pathMatch: 'full', component: ErrorComponent}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
